import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "CampaignEditorRightColumn" }
const _hoisted_2 = { class: "CampaignEditorOverviewBlock CampaignEditorOverviewRightsBlock" }
const _hoisted_3 = { class: "CampaignEditorOverviewTitle" }
const _hoisted_4 = { class: "CampaignEditorOverviewSubtitle" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 1,
  class: "CampaignEditorText CampaignEditorTextInformative"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingWrapper = _resolveComponent("LoadingWrapper")!

  return (_openBlock(), _createBlock(_component_LoadingWrapper, {
    classes: [
			'CampaignEditorRow',
			'OverviewBlockWrapper'
		],
    isLoading: _ctx.isLoading
  }, {
    default: _withCtx(() => [
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "CampaignEditorLeftColumn" }, [
        _createElementVNode("label", { class: "CampaignEditorInputLabel DropdownLabel" }, " Users with access ")
      ], -1 /* CACHED */)),
      _createElementVNode("div", _hoisted_1, [
        (_ctx.rightsUsers.length)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.rightsUsers, (user) => {
              return (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, _toDisplayString(user.name), 1 /* TEXT */),
                _createElementVNode("div", _hoisted_4, _toDisplayString(user.email), 1 /* TEXT */),
                _createElementVNode("button", {
                  class: "HelperButton CampaignEditorOverviewButton",
                  onClick: ($event: any) => (_ctx.removeRightsUser(user))
                }, [...(_cache[0] || (_cache[0] = [
                  _createTextVNode(" Revoke Access ", -1 /* CACHED */),
                  _createElementVNode("i", { class: "CampaignEditorOverviewButtonIcon lnr-unlink" }, null, -1 /* CACHED */)
                ]))], 8 /* PROPS */, _hoisted_5)
              ]))
            }), 256 /* UNKEYED_FRAGMENT */))
          : (_openBlock(), _createElementBlock("div", _hoisted_6, " No users have been given access to this campaign. "))
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["isLoading"]))
}